// extracted by mini-css-extract-plugin
module.exports = {"videocenter":"videocenter-overview_videocenter__IpRJx","breadcrumb":"videocenter-overview_breadcrumb__ikg4h"};